import * as React from "react";

export interface CredContextValue {
    isEligible: boolean;
    bannerText: string;
    isOfferLoading: boolean;
}

export const CredEligiblityContext = React.createContext<CredContextValue>({
    isEligible: false,
    bannerText: "",
    isOfferLoading: false,
});

if (__DEV__) {
    CredEligiblityContext.displayName = "CredContext";
}
